import { acceptAgreement, muteFlightroom } from '@connect-x-app/hybrid-data-access';
import { ApiError, FlightStatus, QueryKeys } from '@connect-x-app/shared-domain-models';
import { MutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';

export const useUpdateMute = (options?: MutationOptions<void, ApiError, Parameters<typeof muteFlightroom>[0], void>) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: muteFlightroom,
    mutationKey: [QueryKeys.MUTE_FLIGHTROOM],
    ...options,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QueryKeys.FLIGHTROOMS, FlightStatus.ACTIVE] }),
  });
};

export const useAcceptEula = (options?: MutationOptions<void, ApiError, number>) =>
  useMutation<void, ApiError, number>({ mutationFn: acceptAgreement, mutationKey: [QueryKeys.ACCEPT_AGREEMENT], ...options });
